import axios from "axios";
import { ORDER_PROXY_API } from "constants/apiUrls";

// 포스 상점 IDX 조회
export const getShopMappingApi = async (shopId) => {
  const response = await axios.get(`${ORDER_PROXY_API}/shop/v2/pos/shop-code`, {
    params: {
      channelType: 2,
      shopId: shopId
    }
  });

  return response.data.shopId;
}

// 포스 메뉴그룹 IDX 조회
export const getMenuGrpMappingApi = async (grpId) => {
  const response = await axios.get(`${ORDER_PROXY_API}/product/v2/pos/group/code`, {
    params: {
      channelType: 2,
      productGroupId: grpId
    }
  });

  return response.data.productGroupId;
}

// 포스 메뉴 IDX 조회
export const getMenuMappingApi = async (menuId) => {
  const response = await axios.get(`${ORDER_PROXY_API}/product/v2/pos/product-code`, {
    params: {
      channelType: 2,
      productId: menuId
    }
  });

  return response.data.productId;
}

// 포스 옵션 그룹 IDX 조회
export const getOptionGrpMappingApi = async (optionGrpId) => {
  const response = await axios.get(`${ORDER_PROXY_API}/product/v2/pos/option-group/code`, {
    params: {
      channelType: 2,
      productOptionGroupId: optionGrpId
    }
  });

  return response.data.productOptionGroupId;
}

// 메뉴 그룹 매핑
export const setMenuGrpMappingApi = async (data) => {
  await axios.post(`${ORDER_PROXY_API}/product/v2/mapping/group/code`, data);
}

// 메뉴 매핑
export const setMenuMappingApi = async (data) => {
  await axios.post(`${ORDER_PROXY_API}/product/v2/mapping/code`, data);
}